export const validatePassword = (password: string): string | null => {
    const requirements = [
        { regex: /.{8,}/, message: "Password must be at least 8 characters long." },
        { regex: /[A-Z]/, message: "Password must contain at least one uppercase letter." },
        { regex: /[a-z]/, message: "Password must contain at least one lowercase letter." },
        { regex: /[0-9]/, message: "Password must contain at least one digit." },
        { regex: /[@$!%*?&]/, message: "Password must contain at least one special character (@, $, !, %, *, ?, &)." },
    ];

    for (const { regex, message } of requirements) {
        if (!regex.test(password)) {
            return message; // Return the first unmet requirement
        }
    }
    return null; // Return null if all requirements are met
};

